import {
  getErrorCopyFromCode,
  userErrorMessages,
} from '@app/pages/cart/errorDict';
import {
  UpdateLineItemAPIError,
  UpdateLineItemErrorCodes,
} from '@app/types/monolith/types';
import { IntlShape, MessageDescriptor } from '@redbubble/next/intl';
import {
  CART_TRAY_MSG_SEVERITY,
  CART_TRAY_MSG_TYPE,
  Message,
} from '../Messages';

export const getUpdateLineItemErrorMessage = (
  error: UpdateLineItemAPIError['error'],
  intl: IntlShape
) => {
  const inlineErrors: string[] = [];
  const generalErrors: Message[] = [];

  let errorStr: MessageDescriptor;

  try {
    errorStr = getErrorCopyFromCode({ code: error.error_code });
  } catch {
    errorStr = userErrorMessages.lineItemUnhandledUpdateError;
  }

  const userMessage = intl.formatMessage(errorStr, error.error_params);

  if (error.error_code === UpdateLineItemErrorCodes.QuantityInvalid) {
    inlineErrors.push(userMessage);
  } else {
    generalErrors.push({
      severity: CART_TRAY_MSG_SEVERITY.Error,
      text: userMessage,
      type: CART_TRAY_MSG_TYPE.Error,
    });
  }

  return { inlineErrors, generalErrors };
};
